import * as React from 'react';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { Details } from '../../components/Details';
import { useSelector } from 'react-redux';
import { getUrl } from './utils';
import { getWebview } from '../../selectors';
import { trackBlockInPageViewed } from '../../tracking';
import { EBlockInPageName } from '../../types/share';
import { trackMoreInfoClick } from './tracking';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../constants/actionAfterViewed';

export function DetailsContainer() {
  const webview = useSelector(getWebview);
  const url = getUrl(webview);

  const trackViewed = React.useCallback(() => {
    trackBlockInPageViewed(EBlockInPageName.MoreInfo);
  }, []);

  const onClick = React.useCallback(() => {
    trackMoreInfoClick();
  }, []);

  return (
    <ActionAfterViewed callback={trackViewed} timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}>
      <Details url={url} onClick={onClick} />
    </ActionAfterViewed>
  );
}
